import {archiveFilter} from "../../resources/js/modules/archiveFilter";

window.addEventListener('DOMContentLoaded', function(){
  archiveFilter();
})
